//import components
import Breadcrumb from '../components/dynamic/Breadcrumb';

//import locales
import { useTranslation } from "react-i18next";
import "../i18n";

export default function Fail() {

    //get locale
    const { t } = useTranslation();

    return (
        <>
            <Breadcrumb title={t('fail')} />
            <div className='container mx-auto mt-12 px-3'>
                <div className='flex flex-col items-center'>
                    <svg width="120" height="120" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="26" cy="26" r="25" fill="none" stroke="#D72828" stroke-width="2"
                                stroke-dasharray="157" stroke-dashoffset="157">
                            <animate attributeName="stroke-dashoffset" to="0" dur="0.5s" fill="freeze" />
                        </circle>

                        <line x1="16" y1="16" x2="36" y2="36" stroke="#D72828" stroke-width="2"
                                stroke-dasharray="28" stroke-dashoffset="28">
                            <animate attributeName="stroke-dashoffset" to="0" dur="0.3s" begin="0.5s" fill="freeze" />
                        </line>

                        <line x1="36" y1="16" x2="16" y2="36" stroke="#D72828" stroke-width="2"
                                stroke-dasharray="28" stroke-dashoffset="28">
                            <animate attributeName="stroke-dashoffset" to="0" dur="0.3s" begin="0.8s" fill="freeze" />
                        </line>
                    </svg>

                    <div className='mt-10 text-[16px] lg:text-[20px] font-semibold text-center'>
                        {t('fail_payment')}
                    </div>
                </div>
            </div>
        </>
    );
}